export default function Observerjs() {
    this.init = function(){
        if ('IntersectionObserver' in window){
            var elementsEffect = combineNodeLists(
                document.querySelectorAll('.braney-wrapper'),
            );
            effectsNormal(elementsEffect);
            effectsList(elementsEffect);

            // handleVideo
            var elementsVideo = combineNodeLists(
                document.querySelectorAll('video'),
            );

            videoHandle(elementsVideo);


            const observer = new MutationObserver(function (mutationsList, observer) {
                for (const mutation of mutationsList) {
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                let listNodeEffects = node.querySelectorAll('.braney-wrapper');
                                effectsNormal(listNodeEffects);
                                effectsList(listNodeEffects);

                                let listNodeVideo = node.querySelectorAll('.braney-wrapper');
                                videoHandle(listNodeVideo);
                            }
                        });
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }

    function combineNodeListsCustom(...nodeLists) {
        const arrays = nodeLists.map(nodeList => Array.from(nodeList));
        const combinedArray = [].concat(...arrays);
        combinedArray.sort((a, b) => {
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
        return combinedArray;
    }

    const videoHandle = function(elementsVideo){
        const observerNormal = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const target = entry.target;
                if (entry.isIntersecting){
                    target.play();       
                }else{
                    target.pause();
                }
            })
        }, {
            threshold: 0.33
        })
        elementsVideo.forEach(element => observerNormal.observe(element));
    }
    
    const effectsNormal = function(elementsEffect){
        const observerNormal = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting){
                    const apears = combineNodeListsCustom(
                        entry.target.querySelectorAll('.obj-opacity'),
                        entry.target.querySelectorAll('.obj-left'),
                        entry.target.querySelectorAll('.obj-right'),
                        entry.target.querySelectorAll('.obj-top'),
                        entry.target.querySelectorAll('.obj-custom'),
                    );

                    apears.forEach(function(appear, idx){
                        let stagger = appear.dataset.stagger ? appear.dataset.stagger : 250;
                        setTimeout(()=> {
                            appear.classList.add('animated');
                        }, stagger * idx);
                    })
                    observerNormal.unobserve(entry.target);
                }
            })
        }, {
            threshold: 0.33
        })
        
        elementsEffect.forEach(element => observerNormal.observe(element));
    }

    const effectsList = function(elementsEffect){
        const observerNormal = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting){
                    const apears = combineNodeListsCustom(
                        entry.target.querySelectorAll('.obj-list .obj-item'),
                    );
                    apears.forEach(function(appear, idx){
                        setTimeout(()=> {
                            appear.classList.add('animated');
                        }, 300 * idx);
                    })
                    observerNormal.unobserve(entry.target);
                }
            })
        }, {
            threshold: 0.33
        })
        
        elementsEffect.forEach(element => observerNormal.observe(element));
    }

    function combineNodeLists() {
        var nodeListArray = [];
        for (var i = 0; i < arguments.length; i++) {
            if (arguments[i] instanceof NodeList) {
                nodeListArray = nodeListArray.concat(Array.from(arguments[i]));
            } else {
                console.error('Argument at index ' + i + ' is not a NodeList');
            }
        }
        return nodeListArray;
    }
}